<form [formGroup]="form">

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeAllianz">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA ALLIANZ</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeAllianz.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAllianzCapitalDeath"
                     [howdenControlError]="vAllianzCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vAllianzCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAllianzCapitalIptp"
                     [howdenControlError]="vAllianzCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vAllianzCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAllianzCapitalIap"
                     [howdenControlError]="vAllianzCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vAllianzCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeAllianz)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeAllianz)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeAllianz)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeAllianz.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeAllianz.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeAllianz); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeAllianz); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeAxa">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA AXA</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeAxa.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAxaCapitalDeath"
                     [howdenControlError]="vAxaCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vAxaCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAxaCapitalIptp"
                     [howdenControlError]="vAxaCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vAxaCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAxaCapitalIap"
                     [howdenControlError]="vAxaCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vAxaCapitalIapError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Enf. Grave</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vAxaCapitalSevereIllness"
                     [howdenControlError]="vAxaSevereIllnessError" [howdenMax]="9999999"/>
              <mat-error #vAxaSevereIllnessError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeAxa)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeAxa)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeAxa)) {
            <howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeAxa.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeAxa.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeAxa); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeAxa); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeStaLucia">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA StaLucia</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeStaLucia.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vStaLuciaCapitalDeath"
                     [howdenControlError]="vStaLuciaCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vStaLuciaCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vStaLuciaCapitalIptp"
                     [howdenControlError]="vStaLuciaCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vStaLuciaCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vStaLuciaCapitalIap"
                     [howdenControlError]="vStaLuciaCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vStaLuciaCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeStaLucia)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeStaLucia)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeStaLucia)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeStaLucia.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeStaLucia.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeStaLucia); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeStaLucia); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeSurne">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA SURNE</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeSurne.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneCapitalDeath"
                     [howdenControlError]="vSurneCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vSurneCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneCapitalIptp"
                     [howdenControlError]="vSurneCapitalIptpError"
                     [howdenMax]="9999999"/>
              <mat-error #vSurneCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneCapitalIap"
                     [howdenControlError]="vSurneCapitalIapError"
                     [howdenMax]="9999999"/>
              <mat-error #vSurneCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeSurne)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeSurne)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeSurne)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeSurne.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeSurne.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeSurne); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeSurne); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeSurneLifePro">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA SURNE LIFE PRO</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeSurneLifePro.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneLifeProCapitalDeath"
                     [howdenControlError]="vSurneLifeProCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vSurneLifeProCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneLifeProCapitalIptp"
                     [howdenControlError]="vSurneLifeProCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vSurneLifeProCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vSurneLifeProCapitalIap"
                     [howdenControlError]="vSurneLifeProCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vSurneLifeProCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeSurneLifePro)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeSurneLifePro)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeSurneLifePro)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeSurneLifePro.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeSurneLifePro.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeSurneLifePro); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeSurneLifePro); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeHelvetia">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA HELVETIA</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeHelvetia.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vHelvetiaCapitalDeath"
                     [howdenControlError]="vHelvetiaCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vHelvetiaCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vHelvetiaCapitalIptp"
                     [howdenControlError]="vHelvetiaCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vHelvetiaCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vHelvetiaCapitalIap"
                     [howdenControlError]="vHelvetiaCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vHelvetiaCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeHelvetia)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeHelvetia)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeHelvetia)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeHelvetia.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeHelvetia.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeHelvetia); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeHelvetia); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifePrebal">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA PREVIS</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifePrebal.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vPrebalCapitalDeath"
                     [howdenControlError]="vPrebalCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vPrebalCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vPrebalCapitalIptp"
                     [howdenControlError]="vPrebalCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vPrebalCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vPrebalCapitalIap"
                     [howdenControlError]="vPrebalCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vPrebalCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifePrebal)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifePrebal)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifePrebal)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifePrebal.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifePrebal.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifePrebal); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifePrebal); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

<div class="flex margin-top-15 f-gap--10px" formGroupName="lifePrebalInvPro">
  <mat-card appearance="outlined">
    <mat-card-header class="flex f-jc--center">
      <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA PREVIS INV PRO</mat-card-title>
      <howden-label-value class="f-basis--2 group-result-rmbonus"
                          [value]="lifePrebalInvPro.productName || ''">
      </howden-label-value>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content class="margin-top-15">
      <div class="flex" style="align-items:flex-start;">
        <div class="f-basis--6 flex f-gap--10px">

          <mat-form-field class="field-inputs" style="margin-bottom:0">
            <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
            <input matInput type="number" inputmode="decimal" min="0" step="any"
                   formControlName="vPrebalInvProCapitalIptp"
                   [howdenControlError]="vPrebalInvProCapitalIptpError" [howdenMax]="9999999"/>
            <mat-error #vPrebalInvProCapitalIptpError></mat-error>
          </mat-form-field>

          <mat-form-field class="field-inputs" style="margin-bottom:0">
            <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
            <input matInput type="number" inputmode="decimal" min="0" step="any"
                   formControlName="vPrebalInvProCapitalIap"
                   [howdenControlError]="vPrebalInvProCapitalIapError" [howdenMax]="9999999"/>
            <mat-error #vPrebalInvProCapitalIapError></mat-error>
          </mat-form-field>
        </div>

        @if (showTrace(lifePrebalInvPro)) {
          <div class="f-basis--4">
            <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifePrebalInvPro)"></div>
          </div>
        }

        <div class="f-basis--2 group-result-rmbonus">
          @if (shouldShowZeroState(lifePrebalInvPro)) {
            <howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
          } @else {
            @if (lifePrebalInvPro.chargeable) {
              <howden-label-value labelText="Prima" [value]="lifePrebalInvPro.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(lifePrebalInvPro); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(lifePrebalInvPro); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="lifeZurich">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">VIDA ZURICH</mat-card-title>
        <howden-label-value class="f-basis--2 group-result-rmbonus" [value]="lifeZurich.productName || ''"></howden-label-value>
      </mat-card-header>
      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6 flex f-gap--10px">
            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">Fallecimiento</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vZurichCapitalDeath"
                     [howdenControlError]="vZurichCapitalDeathError" [howdenMax]="9999999"/>
              <mat-error #vZurichCapitalDeathError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPT</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vZurichCapitalIptp"
                     [howdenControlError]="vZurichCapitalIptpError" [howdenMax]="9999999"/>
              <mat-error #vZurichCapitalIptpError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs" style="margin-bottom:0">
              <mat-label i18n="@@app.sane-projects.calculator.label">IPA</mat-label>
              <input matInput type="number" inputmode="decimal" min="0" step="any"
                     formControlName="vZurichCapitalIap"
                     [howdenControlError]="vZurichCapitalIapError" [howdenMax]="9999999"/>
              <mat-error #vZurichCapitalIapError></mat-error>
            </mat-form-field>
          </div>

          @if (showTrace(lifeZurich)) {
            <div class="f-basis--4">
              <div class="trace-container" style="margin:0;padding:0" [innerHTML]="getTraceHtml(lifeZurich)"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (shouldShowZeroState(lifeZurich)) {
<howden-label-value labelText="Prima" [value]="(0 | number:'1.2-2') ?? undefined"></howden-label-value>
            } @else {
              @if (lifeZurich.chargeable) {
                <howden-label-value labelText="Prima" [value]="lifeZurich.bonus | bonus"></howden-label-value>
                <br />
              } @else {
                @for (m of getMessages(lifeZurich); track $index) {
                  @if (m.blocking) {
                    <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                  }
                }
              }

              @for (m of getMessages(lifeZurich); track $index) {
                @if (!m.blocking) {
                  <br />
                  <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

</form>
